import { Tag } from '@sunwebgroup/uds-ui/tag'
import { useIntl } from 'react-intl'

interface BookingTagsProps {
  isTotallySnow?: boolean
  isPrimavera?: boolean
  isAddedByYou?: boolean
  isGroupBooking?: boolean
  isMasterBooking?: boolean
  isBookingExchanged?: boolean
  isCancelled?: boolean
  isOnHolidays?: boolean
  hasChanges?: boolean
  daysUntilDeparture?: number | null
}

interface TagConfig {
  isVisible: boolean
  variant: 'totally' | 'primavera' | 'neutral-tinted' | 'success-tinted' | 'success'
  messageId: string
  values?: Record<string, string | number>
}

function getTagsToRender(props: BookingTagsProps): TagConfig[] {
  const {
    isTotallySnow,
    isPrimavera,
    isAddedByYou,
    isCancelled,
    isOnHolidays,
    daysUntilDeparture,
    isGroupBooking,
    isMasterBooking,
    isBookingExchanged,
    hasChanges,
  } = props

  return [
    {
      isVisible: isTotallySnow ?? false,
      variant: 'totally',
      messageId: 'collection_name_totally_snow',
    },
    {
      isVisible: isPrimavera ?? false,
      variant: 'primavera',
      messageId: 'collection_name_primavera',
    },
    {
      isVisible: isAddedByYou ?? false,
      variant: 'neutral-tinted',
      messageId: 'bookings_overview_added_by_you',
    },
    {
      isVisible: isOnHolidays ?? false,
      variant: 'neutral-tinted',
      messageId: 'bookings_overview_on_holidays',
    },
    {
      isVisible: Boolean(daysUntilDeparture),
      variant: 'success-tinted',
      messageId: daysUntilDeparture === 1 ? 'one_day_left' : 'days_left',
      values: { days: daysUntilDeparture ?? 0 },
    },
    {
      isVisible: isGroupBooking ?? false,
      variant: 'neutral-tinted',
      messageId: 'group_booking_label',
    },
    {
      isVisible: (isGroupBooking ?? false) && (isMasterBooking ?? false),
      variant: 'neutral-tinted',
      messageId: 'group_booking_master_label',
    },
    {
      isVisible: Boolean(isCancelled && isBookingExchanged),
      variant: 'success',
      messageId: 'booking_has_been_exchanged_label',
    },
    {
      isVisible: Boolean(isCancelled && !isBookingExchanged),
      variant: 'neutral-tinted',
      messageId: 'common_cancelled',
    },
    {
      isVisible: hasChanges ?? false,
      variant: 'neutral-tinted',
      messageId: 'booking_has_changes_label',
    },
  ]
}

export function BookingTags(props: BookingTagsProps) {
  const intl = useIntl()
  const tagsToRender = getTagsToRender(props)

  return (
    <>
      {tagsToRender
        .filter(tag => tag.isVisible)
        .map(tag => (
          <Tag
            key={tag.messageId}
            size="M"
            variant={tag.variant}
          >
            {intl.formatMessage({ id: tag.messageId }, tag.values)}
          </Tag>
        ))}
    </>
  )
}
